var _g, _g2, _g3, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 764,
    height: 820,
    viewBox: "0 0 764 820",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_870_431)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 381.977,
    cy: 381.821,
    r: 195.821,
    fill: "url(#paint0_linear_870_431)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_870_431)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.887,
    y: 367.015,
    width: 188.179,
    height: 266.985,
    fill: "url(#paint1_linear_870_431)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_iii_870_431)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 374.757,
    cy: 406.757,
    rx: 137.636,
    ry: 137.636,
    transform: "rotate(97.1786 374.757 406.757)",
    fill: "url(#paint2_linear_870_431)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M415.858 382.928C413.093 381.348 409.539 381.348 406.379 382.928L384.262 395.961L369.254 404.255L347.533 417.288C344.768 418.868 341.213 418.868 338.054 417.288L321.071 407.019C318.307 405.44 316.332 402.28 316.332 398.726V378.978C316.332 375.819 317.912 372.659 321.071 370.685L338.054 360.811C340.819 359.231 344.373 359.231 347.533 360.811L364.515 371.08C367.28 372.659 369.254 375.819 369.254 379.373V392.407L384.262 383.718V370.29C384.262 367.13 382.682 363.971 379.523 361.996L347.928 343.434C345.163 341.854 341.608 341.854 338.449 343.434L306.064 362.391C302.904 363.971 301.324 367.13 301.324 370.29V407.414C301.324 410.574 302.904 413.733 306.064 415.708L338.054 434.27C340.819 435.85 344.373 435.85 347.533 434.27L369.254 421.632L384.262 412.944L405.984 400.305C408.749 398.726 412.303 398.726 415.463 400.305L432.445 410.179C435.21 411.759 437.185 414.918 437.185 418.473V438.22C437.185 441.379 435.605 444.539 432.445 446.514L415.858 456.387C413.093 457.967 409.539 457.967 406.379 456.387L389.397 446.514C386.632 444.934 384.657 441.774 384.657 438.22V425.582L369.649 434.27V447.304C369.649 450.463 371.229 453.623 374.389 455.597L406.379 474.16C409.144 475.739 412.698 475.739 415.858 474.16L447.848 455.597C450.613 454.018 452.587 450.858 452.587 447.304V409.784C452.587 406.624 451.008 403.465 447.848 401.49L415.858 382.928Z",
    fill: "#CCBAFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_870_431",
    x: 0.280167,
    y: 0.124451,
    width: 763.393,
    height: 763.393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.9378,
    result: "effect1_foregroundBlur_870_431"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_870_431",
    x: 102.011,
    y: 181.14,
    width: 559.93,
    height: 638.736,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.9378,
    result: "effect1_foregroundBlur_870_431"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_iii_870_431",
    x: 183.822,
    y: 192.986,
    width: 328.585,
    height: 381.869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -53.2838,
    dy: -76.1197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.9096
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.676044 0 0 0 0 0.235556 0 0 0 0 0.883333 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_870_431"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 30.4479
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.4168
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7625 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_870_431",
    result: "effect2_innerShadow_870_431"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.2501
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_870_431",
    result: "effect3_innerShadow_870_431"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_870_431",
    x1: 381.977,
    y1: 186,
    x2: 381.977,
    y2: 577.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF29C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_870_431",
    x1: 381.976,
    y1: 367.015,
    x2: 381.976,
    y2: 634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_870_431",
    x1: 246.491,
    y1: 353.459,
    x2: 408.726,
    y2: 421.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52CDFF",
    stopOpacity: 0.49
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.8aaaa932ee48956b367f6a5c37cec6d0.svg";
export { ForwardRef as ReactComponent };